import { render, staticRenderFns } from "./RetencaoFilter.vue?vue&type=template&id=1e76d332"
import script from "./RetencaoFilter.vue?vue&type=script&lang=js"
export * from "./RetencaoFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports